<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Your health is your greatest wealth, take care of your health and enjoy
              your wealth
            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top uk-margin-remove-bottom">
          <div class="uk-container uk-container-small">
            <h1 class=" uk-text-center specHeading">Health and Wellness</h1>

            <div class="uk-child-width-1-1@m" uk-grid>

              <div >
                <p class=" uk-padding">
                  Our mission is to improve the overall health of the students, staff and members through the
                  provision of quality professional health care. The Health and Wellness team – including a
                  certified physician, registered nurses and medical support staff – caters to patients’ holistic health
                  by offering primary health care, health promotion and disease prevention while pointing patients
                  to Christ, the Great Physician.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-margin-remove-top uk-margin-large-bottom">
          <div class="uk-container uk-container-small">
            <div class="uk-child-width-1-2@m" uk-grid>

              <div >
                <h3 class="uk-heading-bullet specHeading">Services Offered</h3>
                <ul class="uk-list uk-list-bullet ">
                  <li>Treats minor injuries and complaints</li>
                  <li>Makes referrals to the Mandeville Regional Hospital and/or Hargreaves Memorial Hospital depending on patient’s case and preference.</li>
                  <li>Responds to on-campus emergencies of varying degrees</li>
                  <li>Conducts outreach programmes in the community or where the need is, annual Health Week activities</li>

                </ul>
              </div>
              <div>
                <div class=" uk-child-width-1-1@l uk-child-width-1-1@m" uk-grid>
                  <div  class="uk-visible@m">
                    <img class="uk-border-circle uk-align-center" src="../assets/health1.jpg" width="200" height="200" alt="Border circle">
                  </div>
                </div>
              </div>
            </div>
            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <h3 class="uk-heading-divider uk-text-center specHeading">Doctor's Hours</h3>
                <span class="uk-text-muted uk-text-bold">
                Walk-in, i.e., no appointments necessary.

              </span>
                <ul class="uk-list uk-list-bullet ">
                  <li>Mondays: 9:00AM to 12:00MD</li>
                  <li>Tuesdays and Thursdays: 9:00AM to 3:00PM</li>
                </ul>
              </div>
              <div>
                <h3 class="uk-heading-divider uk-text-center specHeading">Gynaecological Visits</h3>
                <span class="uk-text-muted  uk-text-bold">
                By appointments ONLY.

              </span>
                <ul class="uk-list uk-list-bullet ">
                  <li>We offer OB/GYN services once per month. Look out for broadcast messages via your NCU
                    email and/or the daily publication of the NCU E-Bulletin. For further information, please feel
                    free to contact us.</li>
                </ul>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </transition>
</template>

<script>
    export default {
        name: "healthwellness",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Health and Wellness Department',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Health and Wellness Department at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h3{
      font-size: 1.2em !important;
    }
    h1{
      font-size: 1.4em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
